<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group" v-if="groupedLocations">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.categoria') }}</label>
              <select v-model="selectedCategory" class="form-control" :disabled="loading">
                <option
                  v-for="category in categories"
                  :key="category.value"
                  :value="category.value"
                >
                  {{ category.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Produs</label>
              <el-select
                v-model="selectedProduct"
                @change="handleProductSelect"
                @clear="handleClearProduct"
                placeholder="Caută produsul..."
                filterable
                remote
                clearable
                :remote-method="fetchProducts"
                :loading="loadingProducts"
                :disabled="loading"
              >
                <el-option
                  v-for="product in searchProdResults"
                  :key="product._id"
                  :label="product.name"
                  :value="product._id"
                >
                  <template #default>
                  {{ product.name }}
                  <span
                    v-if="product.categorie"
                    :class="getCategoryClass(product.categorie)"
                    style="margin-left: 6px; padding: 2px 6px; border-radius: 50px; color: white; font-size: 11px;"
                  >
                    {{ product.categorie }}
                  </span>
                </template>
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Date și oră</label>
              <el-date-picker
                type="datetimerange"
                v-model="searchDate"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="w-100"
                :picker-options="pickerOptions"
                :disabled="loading || !selectedGestiune"
                placeholder="Selectează intervalul"
              ></el-date-picker>
            </div>
          </div>
         </div>
         <div class="right-buttons">
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="triggerFilter"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
         </div>
      </div>
      <div class="card" style="background: #fff; border: none;">
        <div class="card-content" style="display: flex; align-items: center; padding: 0px 5px;">
          <div class="search-button-reports pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="fetchInventoryReport('xls')">{{$t('general.download_xls') }} <img src="/static/img/export_xls.png"></div>
          </div>
          <!-- <div class="search-button-reports pull-left">
            <div :title="$t('reports.export')" class="btn btn-icon btn-xls-slim" @click="fetchInventoryReport('pdf')">{{$t('general.download_pdf') }} <img src="/static/img/export_xls.png"></div>
          </div> -->
        </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="tableInvoice" style="overflow-x: auto;">
              <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="min-width: max-content;">
                <el-table-column prop="denumire" label="Denumire" min-width="200"></el-table-column>

                <el-table-column prop="categorie" label="Categorie" min-width="180"></el-table-column>

                <el-table-column prop="um" label="UM" min-width="80"></el-table-column>

                <el-table-column prop="deschidere" label="Stoc Inițial" min-width="120"
                  :formatter="(row) => Number(row.deschidere).toFixed(2)">
                </el-table-column>

                <el-table-column prop="intrare" label="Intrări/Livrări" min-width="120"
                  :formatter="(row) => Number(row.intrare).toFixed(2)">
                </el-table-column>

                <el-table-column prop="transfer" label="Transfer" min-width="100"
                  :formatter="(row) => Number(row.transfer).toFixed(2)">
                </el-table-column>

                <el-table-column prop="pierderiMaterii" label="Pierderi Materii Prime" min-width="200"
                  :formatter="(row) => Number(row.pierderiMaterii).toFixed(2)">
                </el-table-column>

                <el-table-column prop="pierderiProduse" label="Pierderi Produse Finite" min-width="200"
                  :formatter="(row) => Number(row.pierderiProduse).toFixed(2)">
                </el-table-column>

                <el-table-column prop="pauzaMasa" label="Consum Angajați" min-width="170"
                  :formatter="(row) => Number(row.pauzaMasa).toFixed(2)">
                </el-table-column>

                <el-table-column prop="vandute" label="Cant. Produse Vandute" min-width="200"
                  :formatter="(row) => Number(row.vandute).toFixed(2)">
                </el-table-column>

                <el-table-column prop="trebuie" label="Stoc Estimat" min-width="120"
                  :formatter="(row) => Number(row.trebuie).toFixed(2)">
                </el-table-column>

                <el-table-column prop="inventar" label="Inventar" min-width="120"
                  :formatter="(row) => row.inventar !== null ? Number(row.inventar).toFixed(2) : ''">
                </el-table-column>

                <el-table-column prop="inchidere" label="Stoc Final" min-width="120"
                  :formatter="(row) => Number(row.inchidere).toFixed(2)">
                </el-table-column>

                <el-table-column prop="diferenteCant" label="Diferență Cantitate" min-width="170"
                  :formatter="(row) => row.diferenteCant !== null ? Number(row.diferenteCant).toFixed(2) : ''">
                </el-table-column>

                <el-table-column prop="diferenteVal" label="Diferență Valoare" min-width="170"
                  :formatter="(row) => row.diferenteVal !== null ? Number(row.diferenteVal).toFixed(2) : ''">
                </el-table-column>
            </el-table>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import swal from 'sweetalert2'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    const end = new Date()
    const start = new Date()
    start.setDate(end.getDate() - 29)
    start.setHours(0, 0, 0, 0)
    end.setHours(23, 59, 59, 999)

    return {
      loading: false,
      tableData: [],
      searchProdResults: [],
      selectedCategory: '',
      selectedGestiune: null,
      selectedLocation: null,
      selectedProduct: null,
      loadingProducts: false,
      searchDate: [start, end],
      categories: [
        { value: '', label: 'Selectează categoria' },
        { value: 'Marfa', label: 'Marfa' },
        { value: 'Materii prime', label: 'Materii prime' },
        { value: 'Materiale consumabile', label: 'Materiale consumabile' },
        { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
        { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' },
        { value: 'Produs rezidual', label: 'Produs rezidual' },
        { value: 'Ambalaje', label: 'Ambalaje' },
        { value: 'Obiecte de inventar', label: 'Obiecte de inventar' },
        { value: 'fara_categorie', label: 'Fara categorie' }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: 'Astăzi',
            onClick (picker) {
              const start = new Date()
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ieri',
            onClick (picker) {
              const start = new Date()
              start.setDate(start.getDate() - 1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setDate(end.getDate() - 1)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 7 zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Ultimele 30 de zile',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setDate(end.getDate() - 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna curentă',
            onClick (picker) {
              const start = new Date()
              start.setDate(1)
              start.setHours(0, 0, 0, 0)
              const end = new Date()
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Luna trecută',
            onClick (picker) {
              const date = new Date()
              const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
              const end = new Date(date.getFullYear(), date.getMonth(), 0)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul curent',
            onClick (picker) {
              const start = new Date(new Date().getFullYear(), 0, 1)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Anul trecut',
            onClick (picker) {
              const year = new Date().getFullYear() - 1
              const start = new Date(year, 0, 1)
              const end = new Date(year, 11, 31)
              end.setHours(23, 59, 59, 999)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick ({ maxDate, minDate }) {
          if (minDate && !maxDate) {
            minDate.setHours(0, 0, 0, 0)
          }
          if (maxDate) {
            maxDate.setHours(23, 59, 59, 999)
          }
        }
      }
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    selectedLocation (newLocation) {
      this.resetTable()

      this.selectedGestiune = null
      this.selectedProduct = null
      this.tableData = []
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code
    },
    selectedCategory () {
      this.resetTable()

      this.selectedProduct = null
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
    },
    triggerFilter () {
      if (!this.selectedGestiune) {
        return
      }
      if (!this.selectedLocation) {
        return
      }
      if (!this.searchDate || this.searchDate.length !== 2) {
        return
      }

      this.resetTable()
      this.fetchInventoryReport()
    },
    handleProductSelect (product) {
      this.resetTable()

      this.selectedProduct = product
    },
    handleClearProduct () {
      this.resetTable()

      this.selectedProduct = null
    },
    getCategoryClass (categorie) {
      if (!categorie) return ''

      switch (categorie.toLowerCase().replace(/\s+/g, '-')) {
        case 'marfa': return 'marfa'
        case 'semifabricate-(reteta)': return 'semifabricate'
        case 'materii-prime': return 'materii-prime'
        case 'produs-finit-(reteta)': return 'produs-finit'
        default: return ''
      }
    },
    async fetchProducts (searchTerm) {
      if (!searchTerm || searchTerm.length < 2) {
        this.searchProdResults = []
        return
      }

      this.loadingProducts = true

      try {
        let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?vatNumber=${this.selectedVatNumber}&name=${encodeURIComponent(searchTerm)}&externalCompanyId=${this.companyID}`

        if (this.selectedCategory) {
          url += `&categorie=${encodeURIComponent(this.selectedCategory)}`
        }

        const response = await fetch(url)
        const data = await response.json()

        if (Array.isArray(data.products)) {
          this.searchProdResults = [...data.products]
        } else {
          this.searchProdResults = []
        }
      } catch (error) {
        console.error('Error fetching products:', error)
        this.searchProdResults = []
      } finally {
        this.loadingProducts = false
      }
    },
    async fetchInventoryReport (exportFormat = null) {
      if (!this.selectedGestiune || !this.selectedLocation || !this.searchDate) return

      this.loading = true

      swal({
        type: 'info',
        title: 'Se generează raportul în timp real',
        text: 'Vă rugăm așteptați...',
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        }
      })

      try {
        const externalCompanyId = this.$session.get('selectedCompany')
        const [startDate, endDate] = this.searchDate

        // Construim URL cu query parameters
        const queryParams = new URLSearchParams({
          gestiune: this.selectedGestiune,
          externalCompanyId: externalCompanyId,
          externalLocationId: this.selectedLocation.true_id,
          startDate: new Date(startDate),
          endDate: new Date(endDate)
        }).toString()

        let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/reports/inventory?${queryParams}`

        if (this.selectedCategory) {
          url += `&categorie=${encodeURIComponent(this.selectedCategory)}`
        }

        if (this.selectedProduct) {
          url += `&product_id=${this.selectedProduct}`
        }

        if (exportFormat) {
          url += `&export=${exportFormat}`
        }

        // Apel fetch
        const response = await fetch(url)

        if (!response.ok) {
          // Extragem mesajul real din JSON
          let errorMsg = `Eroare necunoscută: ${response.status}`
          try {
            const errData = await response.json()
            // Preferăm details dacă există
            errorMsg = errData.details || errData.error || errorMsg
          } catch (err) {
            console.warn('Nu s-a putut parsa JSON-ul erorii:', err)
          }
          throw new Error(errorMsg)
        }

        if (exportFormat) {
          window.location.href = url

          setTimeout(() => {
            swal.close()
          }, 800)

          return
        }

        const data = await response.json()

        if (data && data.items) {
          this.tableData = data.items.map(item => ({
            denumire: item.product_name || '',
            um: item.unit || '',
            deschidere: item.opening_stock != null ? item.opening_stock : '',
            categorie: item.category != null ? item.category : '',
            intrare: item.delivery != null ? item.delivery : '',
            transfer: item.transfer != null ? item.transfer : '',
            pierderiMaterii: item.raw_waste != null ? item.raw_waste : '',
            pierderiProduse: item.full_waste != null ? item.full_waste : '',
            pauzaMasa: item.crew_meal != null ? item.crew_meal : '',
            vandute: item.usage_pre != null ? item.usage_pre : '',
            trebuie: item.expected_stock != null ? item.expected_stock : '',
            inventar: item.inventory_count != null ? item.inventory_count : '',
            inchidere: item.closing_stock != null ? item.closing_stock : '',
            diferenteCant: item.diff_quantity != null ? item.diff_quantity : '',
            diferenteVal: item.diff_value != null ? item.diff_value : ''
          }))
        } else {
          this.tableData = []
        }
      } catch (error) {
        console.error('Error fetching inventory report:', error)
        swal({
          title: 'Error',
          text: error.message || 'Nu s-a putut genera raportul de inventar.',
          type: 'error'
        })
        this.tableData = []
      } finally {
        this.loading = false
      }
    },
    resetTable () {
      this.tableData = []
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.form-group {
  display: grid;
}
.left-buttons {
  display: flex;
}
.marfa {
  background-color: orange;
  color: #fff;
}
.semifabricate {
  background-color: #219653;
  color: #fff;
}
.materii-prime {
  background-color: #2f80ed;
  color: #fff;
}
.produs-finit {
  background-color: #674BD2;
  color: #fff;
}
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.sticky-column .cell {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/InventoryReport.vue